import { useMutation, UseMutationOptions, useQuery, UseQueryOptions } from "@tanstack/react-query";
import { ApiServiceErr, axiosApi } from "./apiService";

export interface VariantImpactDetails {
  variantId: string;
  variantName: string;
  currentImpactTotal: number;
  impactChangePercentage: number;
  totalImpactChange: number;
}

export interface RecipeImpactDetails {
  _id?: string | undefined;
  recipeId: string;
  productionSize: number;
  originalImpact?: number;
  variantImpactDetails: VariantImpactDetails[];
  tenantId?: string;
  createdBy?: string;
  updatedBy?: string;
}

export const useGetRecipeImpactDetailsByRecipeId = (
  recipeId: string,
  opt?: UseQueryOptions<RecipeImpactDetails, ApiServiceErr>
) =>
  useQuery<RecipeImpactDetails, ApiServiceErr>(
    ["getRecipeImpactDetailsByRecipeId", recipeId],
    async () => {
      const response = await axiosApi.get(`/recipe-impact-details/${recipeId}`);
      return response.data;
    },
    {
      enabled: !!recipeId,
      ...opt
    }
  );

export const useCreateRecipeImpactDetails = (
  opt?: UseMutationOptions<RecipeImpactDetails, ApiServiceErr, RecipeImpactDetails>
) =>
  useMutation<RecipeImpactDetails, ApiServiceErr, RecipeImpactDetails>(
    async data => {
      const response = await axiosApi.post("/recipe-impact-details", data);
      return response.data;
    },
    {
      ...opt
    }
  );

export const useUpdateRecipeImpactDetails = (
  opt?: UseMutationOptions<RecipeImpactDetails, ApiServiceErr, RecipeImpactDetails>
) =>
  useMutation<RecipeImpactDetails, ApiServiceErr, RecipeImpactDetails>(
    async data => {
      const response = await axiosApi.put("/recipe-impact-details", data);
      return response.data;
    },
    {
      ...opt
    }
  );
